export default "__VITE_ASSET__DSJTfwne__"